import { connect } from 'react-redux';
import {SEARCH_QUIZ,ROUTES} from '../constants';
import AlgoliaSearchPage from '../components/pages/AlgoliaSearchPage';

const mapStateToProps = ({searchRecipesReducer,location}) => {
	const refreshSearchQuiz = searchRecipesReducer.refresh;
	const error = searchRecipesReducer.error;
	const {payload,query} = location;
	const {key} = payload;
	return {
		refreshSearchQuiz,
		error:error,
		query,
		key
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onRefresh : () =>dispatch(dispatch({
			type:SEARCH_QUIZ.REFRESH
		})),
		onSearchStateChange : (value) => {
			dispatch({
				type : ROUTES.SEARCH_QUIZ_QUERIED,
				payload : {
					key : 'query',
					query : {
						word : value
					}
				}
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(AlgoliaSearchPage);